import React from "react";
import {connect} from 'react-redux';

const InconsistencyRow = ({
    item,
    index,
    payItems,
    employee,
    sampleTimesheet,
}) => {

  const rowClass = index % 2 == 1 ? "odd" : "even";

  // TODO consider adding a hover of the sampleTimesheet

  const mainRow =
        <tr key={item.agreement} role="row" className={rowClass}>
          <td className="font-w600">
            {employee?.fullName}
            <br/>
            {employee?.roleName} - {employee?.employmentTypeName}
          </td>
          <td>{payItems.join(', ')}</td>


        </tr>

  return [mainRow]



}

const mapStateToProps = (state,ownProps) => {

  const {item} = ownProps

  const employee = state.payroll &&
    state.payroll.employees &&
    state.payroll.employees.find(
      employee => employee.id == item.agreement
    ) || {}

    const overtimes = state.company.settings.overtimes
    const allowances = state.company.settings.allowances

    const payItems = []

    item.inconsistencies?.allowances.map(id => {
        // get name from
        const name = allowances.find(a => a.id == id)?.name
        payItems.push(name)
    })

    item.inconsistencies?.overtimes.map(id => {
        const name = overtimes.find(a => a.id == id)?.name
        payItems.push(name)
    })

    const sampleTimesheet = item.inconsistencies.sampleTimesheet

  return {
    employee,
    payItems,
    sampleTimesheet,
  }
}

const mapDispatchToProps = dispatch => ({
  // leaveGetBalances: (until) => dispatch(ACTIONS.leaveGetBalances(until)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InconsistencyRow)
